<p-floatLabel>
	<p-dropdown 
		[options]="options" 
		[(ngModel)]="value"
		(onChange)="valueEmit()"
		[optionLabel]="optionLabel" 
		[placeholder]="placeholder"
		[inputId]="id"
		[disabled]="disabled || loading"
	/>
	<label for="{{ id }}" *ngIf="!loading">
		{{ label }}
		<span class="required" *ngIf="required">*</span>
	</label>
</p-floatLabel>
<app-loading *ngIf="loading" extraClass="inline small loading-s"></app-loading>
